import { sumBy } from 'lodash';
import {
  TIMELINES_ITEM_ROW_HEIGHT,
  OTHER_LABEL_VERTICAL_MARGIN,
  TIMELINE_MODERNIZED_GROUP_INDENTATION,
  TIMELINE_MODERNIZED_COMPONENT_INDENTATION,
  TIMELINE_INDIVIDUAL_ITEM_MARGIN,
} from './consts';
import { TimelineLabelWithRenderingParameters } from '../types';

export const getTotalLabelsHeight = ({
  otherLabelsRenderingData,
  isFieldDataCollapsed,
}: TimelineLabelWithRenderingParameters) => {
  const otherLabelsData = otherLabelsRenderingData?.labelsData;
  if (!otherLabelsData?.length) {
    return TIMELINES_ITEM_ROW_HEIGHT;
  }

  const otherLabelsHeight = isFieldDataCollapsed
    ? 0
    : sumBy(otherLabelsData, 'height') +
      OTHER_LABEL_VERTICAL_MARGIN * otherLabelsData.length;

  return TIMELINES_ITEM_ROW_HEIGHT + otherLabelsHeight;
};

export const getModernizedItemTreeIndentation = (
  treeDepth: number,
  isGroup?: boolean,
  hasSiblingGroup?: boolean
): number => {
  if (!treeDepth) {
    return hasSiblingGroup ? TIMELINE_INDIVIDUAL_ITEM_MARGIN : 0;
  }

  const groupIndentation =
    (treeDepth - 1) * TIMELINE_MODERNIZED_GROUP_INDENTATION;

  const baseIndentation =
    groupIndentation +
    (isGroup
      ? TIMELINE_MODERNIZED_GROUP_INDENTATION
      : TIMELINE_MODERNIZED_COMPONENT_INDENTATION);

  if (hasSiblingGroup) {
    // Align with group siblings' color indicator, accounting for the tree
    // link width difference between groups and non-groups at depth > 0.
    return (
      baseIndentation +
      TIMELINE_INDIVIDUAL_ITEM_MARGIN +
      TIMELINE_MODERNIZED_GROUP_INDENTATION -
      TIMELINE_MODERNIZED_COMPONENT_INDENTATION
    );
  }

  return baseIndentation;
};
